"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameSteamDataPcRequirementsToJSON = exports.OWGameSteamDataPcRequirementsFromJSONTyped = exports.OWGameSteamDataPcRequirementsFromJSON = void 0;
var runtime_1 = require("../runtime");
function OWGameSteamDataPcRequirementsFromJSON(json) {
    return OWGameSteamDataPcRequirementsFromJSONTyped(json, false);
}
exports.OWGameSteamDataPcRequirementsFromJSON = OWGameSteamDataPcRequirementsFromJSON;
function OWGameSteamDataPcRequirementsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'minimum': !(0, runtime_1.exists)(json, 'minimum') ? undefined : json['minimum'],
        'recommended': !(0, runtime_1.exists)(json, 'recommended') ? undefined : json['recommended'],
    };
}
exports.OWGameSteamDataPcRequirementsFromJSONTyped = OWGameSteamDataPcRequirementsFromJSONTyped;
function OWGameSteamDataPcRequirementsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'minimum': value.minimum,
        'recommended': value.recommended,
    };
}
exports.OWGameSteamDataPcRequirementsToJSON = OWGameSteamDataPcRequirementsToJSON;
